import { computed } from 'vue'
import { useAuthStore } from '../stores/AuthStore'
import {
  buildNavbarLinks,
  isNavigationLinkVisible
} from '../access/navigationLinks'

export function usePermissionGatedNavigation(customNavigation) {
  const authStore = useAuthStore()

  function linkVisible(link) {
    return isNavigationLinkVisible(link, authStore)
  }

  const navbarLinks = computed(() => {
    const routes = customNavigation.value?.routes
    if (!routes) return []
    return buildNavbarLinks(routes).filter(linkVisible)
  })

  return {
    navbarLinks,
    isNavigationLinkVisible: linkVisible
  }
}
